import React from "react";
import { Context, useContext } from "./context";
import { Props } from "./types";
import { Draggable } from "./draggable";
import { DropBox } from "./dropBox";

function DragAndDrop(props: Props) {
  const [state, setState] = React.useState({
    currentPriority: 0,
  });

  return (
    <Context.Provider
      value={{
        ...state,
        setState: (s) =>
          setState((currentState) => ({ ...currentState, ...s })),
      }}
    >
      {props.children}
    </Context.Provider>
  );
}

export { useContext as useDragAndDrop, DragAndDrop, DropBox, Draggable };
